import { render, staticRenderFns } from "./DashboardWings.vue?vue&type=template&id=c6423a14&"
import script from "./DashboardWings.vue?vue&type=script&lang=js&"
export * from "./DashboardWings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports